export enum WizardSteps {
  STEP_ONE   = 'stepOne',
  STEP_TWO   = 'stepTwo',
  STEP_THREE = 'stepThree',
  STEP_FOUR  = 'stepFour',
  STEP_FIVE  = 'stepFive',
  STEP_SIX   = 'stepSix'
}
